<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    fill="none"
    version="1.1"
    width="16"
    height="16"
    viewBox="0 0 16 16"
  >
    <g style="mix-blend-mode: passthrough">
      <g style="mix-blend-mode: passthrough">
        <path
          d="M11,2C11,2,1,2,1,2C0.45,2,0,2.45,0,3C0,3,0,13,0,13C0,13.55,0.45,14,1,14C1,14,15,14,15,14C15.55,14,16,13.55,16,13C16,13,16,7,16,7C16,7,11,2,11,2C11,2,11,2,11,2ZM14,12C14,12,2,12,2,12C2,12,2,4,2,4C2,4,10,4,10,4C10,4,10,6,10,6C10,6,3,6,3,6C3,6,3,7,3,7C3,7,10,7,10,7C10,7,10,8,10,8C10,8,14,8,14,8C14,8,14,12,14,12C14,12,14,12,14,12ZM11,7C11,7,11,4,11,4C11,4,14,7,14,7C14,7,11,7,11,7C11,7,11,7,11,7ZM3,10C3,10,13,10,13,10C13,10,13,9,13,9C13,9,3,9,3,9C3,9,3,10,3,10C3,10,3,10,3,10Z"
          fill-rule="evenodd"
          fill="currentColor"
        />
      </g>
    </g>
  </svg>
</template>
<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'Label',
} as DefineComponent
</script>
